module.exports = __webpack_public_path__ + "static/media/Residential_33.9818fab6.jpg";